import { createMachine } from 'xstate';

export const sessionMachine = createMachine({
  id: 'nextos-session',
  initial: 'checking',
  states: {
    checking: { on: { SESSION_FOUND: 'loading', SESSION_MISSING: 'signedOut', FAILED: 'failed' } },
    signedOut: { on: { LOGIN_STARTED: 'authenticating' } },
    authenticating: { on: { LOGIN_CHALLENGE: 'mfa', LOGIN_SUCCESS: 'loading', LOGIN_FAILED: 'signedOut' } },
    mfa: { on: { LOGIN_SUCCESS: 'loading', LOGIN_FAILED: 'signedOut' } },
    loading: { on: { WORKSPACE_READY: 'ready', SESSION_MISSING: 'signedOut', FAILED: 'failed' } },
    ready: { on: { CONNECTION_LOST: 'reconnecting', LOGOUT: 'signedOut', SESSION_MISSING: 'signedOut' } },
    reconnecting: { on: { CONNECTION_RESTORED: 'ready', SESSION_MISSING: 'signedOut' } },
    failed: { on: { RETRY: 'checking', SESSION_MISSING: 'signedOut' } }
  }
});
